import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from "react";
const HomePage = lazy(() => import("@/pages/HomePage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const PracticeAreasPage = lazy(() => import("@/pages/PracticeAreasPage"));
const SEOLandingPage = lazy(() => import("@/pages/SEOLandingPage"));
const BlogPage = lazy(() => import("@/pages/BlogPage"));
const CriminalDefensePage = lazy(() => import("@/pages/PracticeAreasPage/CriminalDefensePage"));
const CannabisDefensePage = lazy(() => import("@/pages/PracticeAreasPage/CannabisDefensePage"));
const PersonalInjuryPage = lazy(() => import("@/pages/PracticeAreasPage/PersonalInjuryPage"));
const DrugChargesPage = lazy(() => import("@/pages/PracticeAreasPage/DrugChargesPage"));
const GunChargesPage = lazy(() => import("@/pages/PracticeAreasPage/GunChargesPage"));
const ViolentCrimesPage = lazy(() => import("@/pages/PracticeAreasPage/ViolentCrimesPage"));
const PoliceLawsuitsPage = lazy(() => import("@/pages/PracticeAreasPage/PoliceLawsuitsPage"));
const LocationsPage = lazy(() => import("@/pages/LocationsPage"));
const WashingtonDCPage = lazy(() => import("@/pages/LocationsPage/WashingtonDCPage"));
const MontgomeryCountyPage = lazy(() => import("@/pages/LocationsPage/MontgomeryCountyPage"));
const PrinceGeorgesCountyPage = lazy(() => import("@/pages/LocationsPage/PrinceGeorgesCountyPage"));
const PrivacyPolicyPage = lazy(() => import("@/pages/PrivacyPolicyPage"));
const TermsOfServicePage = lazy(() => import("@/pages/TermsOfServicePage"));
const ComingSoon = lazy(() => import("@/pages/ComingSoon"));
const HomePageEs = lazy(() => import("@/pages/es/HomePageEs"));
const AboutPageEs = lazy(() => import("@/pages/es/AboutPageEs"));
const ContactPageEs = lazy(() => import("@/pages/es/ContactPageEs"));
const PracticeAreasPageEs = lazy(() => import("@/pages/es/PracticeAreasPage"));
const CriminalDefensePageEs = lazy(() => import("@/pages/es/PracticeAreasPage/CriminalDefensePageEs"));
const CannabisDefensePageEs = lazy(() => import("@/pages/es/PracticeAreasPage/CannabisDefensePageEs"));
const PersonalInjuryPageEs = lazy(() => import("@/pages/es/PracticeAreasPage/PersonalInjuryPageEs"));
const DrugChargesPageEs = lazy(() => import("@/pages/es/PracticeAreasPage/DrugChargesPageEs"));
const GunChargesPageEs = lazy(() => import("@/pages/es/PracticeAreasPage/GunChargesPageEs"));
const ViolentCrimesPageEs = lazy(() => import("@/pages/es/PracticeAreasPage/ViolentCrimesPageEs"));
const PoliceLawsuitsPageEs = lazy(() => import("@/pages/es/PracticeAreasPage/PoliceLawsuitsPageEs"));
const LocationsPageEs = lazy(() => import("@/pages/es/LocationsPage"));
const WashingtonDCEsPage = lazy(() => import("@/pages/es/LocationsPage/WashingtonDCEsPage"));
const MontgomeryCountyEsPage = lazy(() => import("@/pages/es/LocationsPage/MontgomeryCountyEsPage"));
const PrinceGeorgesCountyEsPage = lazy(() => import("@/pages/es/LocationsPage/PrinceGeorgesCountyEsPage"));
const routes = [
    {
        path: "/",
        element: _jsx(HomePage, {}),
    },
    {
        path: "/about",
        element: _jsx(AboutPage, {}),
    },
    {
        path: "/blog",
        element: _jsx(BlogPage, {}),
    },
    {
        path: "/practice-areas",
        element: _jsx(PracticeAreasPage, {}),
    },
    {
        path: "/practice-areas/criminal-defense",
        element: _jsx(CriminalDefensePage, {}),
    },
    {
        path: "/practice-areas/cannabis-defense",
        element: _jsx(CannabisDefensePage, {}),
    },
    {
        path: "/practice-areas/personal-injury",
        element: _jsx(PersonalInjuryPage, {}),
    },
    {
        path: "/practice-areas/drug-charges",
        element: _jsx(DrugChargesPage, {}),
    },
    {
        path: "/practice-areas/gun-charges",
        element: _jsx(GunChargesPage, {}),
    },
    {
        path: "/practice-areas/violent-crimes",
        element: _jsx(ViolentCrimesPage, {}),
    },
    {
        path: "/practice-areas/police-lawsuits",
        element: _jsx(PoliceLawsuitsPage, {}),
    },
    {
        path: "/locations/washington-dc",
        element: _jsx(WashingtonDCPage, {}),
    },
    {
        path: "/locations/montgomery-county",
        element: _jsx(MontgomeryCountyPage, {}),
    },
    {
        path: "/locations/montgomery-county-md",
        element: _jsx(MontgomeryCountyPage, {}),
    },
    {
        path: "/locations/prince-georges-county",
        element: _jsx(PrinceGeorgesCountyPage, {}),
    },
    {
        path: "/locations/prince-georges-county-md",
        element: _jsx(PrinceGeorgesCountyPage, {}),
    },
    {
        path: "/locations",
        element: _jsx(LocationsPage, {}),
    },
    {
        path: "/privacy-policy",
        element: _jsx(PrivacyPolicyPage, {}),
    },
    {
        path: "/terms-of-service",
        element: _jsx(TermsOfServicePage, {}),
    },
    {
        path: "/contact",
        element: _jsx(ContactPage, {}),
    },
    {
        path: "/es",
        element: _jsx(HomePageEs, {}),
    },
    {
        path: "/es/sobre-nosotros",
        element: _jsx(AboutPageEs, {}),
    },
    {
        path: "/es/areas-de-practica",
        element: _jsx(PracticeAreasPageEs, {}),
    },
    {
        path: "/es/areas-de-practica/defensa-criminal",
        element: _jsx(CriminalDefensePageEs, {}),
    },
    {
        path: "/es/areas-de-practica/defensa-cannabis",
        element: _jsx(CannabisDefensePageEs, {}),
    },
    {
        path: "/es/areas-de-practica/lesiones-personales",
        element: _jsx(PersonalInjuryPageEs, {}),
    },
    {
        path: "/es/areas-de-practica/cargos-de-drogas",
        element: _jsx(DrugChargesPageEs, {}),
    },
    {
        path: "/es/areas-de-practica/cargos-de-armas",
        element: _jsx(GunChargesPageEs, {}),
    },
    {
        path: "/es/areas-de-practica/crimenes-violentos",
        element: _jsx(ViolentCrimesPageEs, {}),
    },
    {
        path: "/es/areas-de-practica/demandas-policiales",
        element: _jsx(PoliceLawsuitsPageEs, {}),
    },
    {
        path: "/es/ubicaciones/washington-dc",
        element: _jsx(WashingtonDCEsPage, {}),
    },
    {
        path: "/es/ubicaciones/condado-montgomery-md",
        element: _jsx(MontgomeryCountyEsPage, {}),
    },
    {
        path: "/es/ubicaciones/condado-prince-georges-md",
        element: _jsx(PrinceGeorgesCountyEsPage, {}),
    },
    {
        path: "/es/ubicaciones",
        element: _jsx(LocationsPageEs, {}),
    },
    {
        path: "/es/contacto",
        element: _jsx(ContactPageEs, {}),
    },
    {
        path: "/es/blog",
        element: _jsx(BlogPage, {}),
    },
    // SEO Landing Pages - English services
    {
        path: "/cannabis-defense/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/car-accident/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/criminal-defense/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/domestic-violence-defense/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/drug-charges-defense/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/dui-defense/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/federal-criminal-defense/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/gun-charges-defense/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/medical-malpractice/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/motorcycle-accident/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/personal-injury/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/probation-violation/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/sex-crimes-defense/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/slip-and-fall/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/truck-accident/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/violent-crimes-defense/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/wrongful-death/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    // SEO Landing Pages - Spanish services
    {
        path: "/defensa-criminal/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/defensa-de-cannabis/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/defensa-de-dui/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/defensa-por-cargos-de-drogas/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/lesiones-personales/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "/negligencia-medica/:citySlug",
        element: _jsx(SEOLandingPage, {}),
    },
    {
        path: "*",
        element: _jsx(ComingSoon, {}),
    },
];
export default routes;
